<div [formGroup]="parentGroup">
    <mat-form-field appearance="fill" [ngClass]="{'invisible':formElement.hidden === 'true'}">
        <mat-label>
            {{ formElement.text }}
        </mat-label>

        <mat-select disableOptionCentering [formControlName]="formElement.formControl" multiple>
            <ng-container *ngIf="options | async as options">
                <mat-option *ngFor="let option of options.data" [value]="option.id">{{option.name}}</mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>
</div>
